import { SrInsightType as InsightType } from '@plato/data/starrocks/types';
import type { TranslationFunction } from '../../../lib/hooks/use-locale.ts';
import type {
    ChurnDimension,
    InsightDTO,
    ResolvedOutcomeInsightDTO,
} from '../../../server/dto/insight-dto.ts';

const dimensionTitleKey: Record<ChurnDimension, string> = {
    d1_silence: 'churn_v2_title__d1_silence',
    d2_cadence: 'churn_v2_title__d2_cadence',
    d3_annual: 'churn_v2_title__d3_annual',
    d4_seasonal: 'churn_v2_title__d4_seasonal',
    d5_revenue: 'churn_v2_title__d5_revenue',
    d6_momentum: 'churn_v2_title__d6_momentum',
    d7_concentration: 'churn_v2_title__d7_concentration',
    d8_global: 'churn_v2_title__d8_global',
};

export const getInsightName = (
    t: TranslationFunction,
    insight: InsightDTO | ResolvedOutcomeInsightDTO,
): string => {
    if (insight.insight_type === InsightType.INDUSTRY_TOP) {
        return t(`insight_name__${insight.insight_type}`, {
            ns: 'insights',
            industry_sector: insight.template_arguments?.industry_sector,
        });
    }

    if (insight.insight_type === InsightType.CHURN_WARNING) {
        const args = insight.template_arguments;
        // Only v2 churn carries dimensions (`top_dimension_1`); v1 and the resolved-outcome shape
        // fall back to the generic churn name. `in` also narrows away the ResolvedOutcomeInsightDTO.
        const dim = args && 'top_dimension_1' in args ? args.top_dimension_1 : undefined;

        return dim
            ? t(dimensionTitleKey[dim], { ns: 'insights' })
            : t(`insight_name__${InsightType.CHURN_WARNING}`, { ns: 'insights' });
    }

    return t(`insight_name__${insight.insight_type}`, {
        ns: 'insights',
    });
};
